var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagIconRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 52,
    viewBox: "0 0 51 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.6689,
    cy: 26,
    rx: 25.1689,
    ry: 26,
    fill: "#FF6633"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7657 18.4404C16.5538 18.1571 17.1194 17.3829 17.1194 16.4722C17.1194 15.3217 16.2165 14.3889 15.1027 14.3889C13.9889 14.3889 13.0859 15.3217 13.0859 16.4722C13.0859 17.3829 13.6515 18.1571 14.4396 18.4404C14.4336 18.4778 14.4304 18.5163 14.4304 18.5556V35.9167C14.4304 36.3002 14.7314 36.6111 15.1027 36.6111C15.474 36.6111 15.7749 36.3002 15.7749 35.9167V18.5556C15.7749 18.5163 15.7718 18.4778 15.7657 18.4404ZM17.1194 18.9932C17.1194 18.7258 17.2674 18.4828 17.5053 18.3773C18.3509 18.0025 20.4303 17.1667 22.1613 17.1667C24.3266 17.1667 27.037 18.4744 27.1958 18.552C27.201 18.5545 27.205 18.5564 27.2102 18.5588C27.3712 18.6325 30.2645 19.9445 32.245 19.9445C33.5584 19.9445 35.2733 19.3675 36.3264 18.9573C36.7823 18.7797 37.2868 19.1239 37.2868 19.6272V29.2125C37.2868 29.4884 37.129 29.7377 36.8812 29.8404C35.9817 30.2131 33.7785 31.0556 32.245 31.0556C30.3412 31.0556 27.4053 29.7571 27.2131 29.6712C27.2061 29.6681 27.2004 29.6653 27.1935 29.662C27.0125 29.5738 24.3168 28.2778 22.1613 28.2778C20.755 28.2778 19.1189 28.8294 18.101 29.2373C17.6399 29.4222 17.1194 29.0756 17.1194 28.5646V18.9932Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagIconRound);
export default __webpack_public_path__ + "static/media/flag-icon-round.ca3ccf1b137b6c325eb5e70c6c9c8bd3.svg";
export { ForwardRef as ReactComponent };